"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),require("react");var index$3=require("../index-de0563bf.js");exports.default=index$3.extractText$1,exports.extractText=index$3.extractText;
